
import { defineComponent } from 'vue'
import { useStore } from '@/store';
import { computed } from '@vue/reactivity';
import { TipoNotificacao } from '@/interfaces/INotificacao';

export default defineComponent({
    // eslint-disable-next-line vue/multi-word-component-names
    name:'Notificacoes',
    data(){
        return{
            contexto:{
                [TipoNotificacao.SUCESSO]: 'is-success',
                [TipoNotificacao.ATENCAO]: 'is-warning',
                [TipoNotificacao.FALHA]: 'is-danger',
            }
        }
    },
    setup(){
        const store = useStore()
        return{
            notificacoes: computed(() => store.state.notificacoes)
        }
    }
});
